import styled from 'styled-components';

export const BannerContainer = styled.div`
  align-items: flex-start;
  object-fit: contain;
  display: flex;
`;

export const BannerIconContainer = styled.div`
  align-self: flex-start;
  margin-right: 10px;
`;

export const BannerTextContainer = styled.div`
  font-size: 13px;
  font-weight: bold;
  margin-right: 15px;
  flex-grow: 2;
`;
